"use strict";

var _marked = /*#__PURE__*/regeneratorRuntime.mark(generator);

Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
/**
 * Prime
 *
 * List of all primes starting from 2
 */
// Check if any of the primes found so far are factors of n. If not, then n is prime, so return that, else repeat for next candidate
var findNextPrime = function findNextPrime(n, knownPrimes) {
    var f = knownPrimes.find(function (p) {
        return n % p === 0;
    });
    return f ? findNextPrime(nextCandidate(n), knownPrimes) : n;
};
// Reduce computation time by only checking odd numbers - and therefore incrementing by 2 each time
// Only exception is the very first increment, because the first prime is 2, the only even prime
var nextCandidate = function nextCandidate(n) {
    return n + (n === 2 ? 1 : 2);
};
// Public API
exports.default = function () {
    return (0, immutable_1.Seq)(generator(2, (0, immutable_1.List)([2])));
};
// Generator
function generator(current) {
    var prev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, immutable_1.List)();
    var knownPrimes, nextPrime;
    return regeneratorRuntime.wrap(function generator$(_context) {
        while (1) {
            switch (_context.prev = _context.next) {
                case 0:
                    _context.next = 2;
                    return current;

                case 2:
                    knownPrimes = prev.push(current);
                    nextPrime = findNextPrime(nextCandidate(current), knownPrimes);
                    return _context.delegateYield(generator(nextPrime, knownPrimes), "t0", 5);

                case 5:
                case "end":
                    return _context.stop();
            }
        }
    }, _marked, this);
}
//# sourceMappingURL=prime.js.map


//////////////////
// WEBPACK FOOTER
// ./client/vendor/number-sequences/dist/prime.js
// module id = 280
// module chunks = 0